/* unplugin-vue-components disabled */import script from "./addOrEditParamsRealName.vue?vue&type=script&setup=true&lang=ts"
export * from "./addOrEditParamsRealName.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__